const KEY_APPLICANTS = 'APPLICANTS'
const GET_APPLICANTS = process.env.REACT_APP_APPLICANTS ?? ''
const DELETE_APPLICANTS = process.env.REACT_APP_APPLICANTS ?? ''
const UPDATE_APPLICANTS = process.env.REACT_APP_APPLICANTS ?? ''

export { GET_APPLICANTS, DELETE_APPLICANTS, UPDATE_APPLICANTS, KEY_APPLICANTS }
